export default "__VITE_ASSET__CHlVJdxn__"